module.exports = __webpack_public_path__ + "static/media/password-created.64546b4f.svg";